import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MobilitySolutionsHero from "./sections/MobilitySolutionsHero";
import EnterprisePartnershipHub from "./sections/EnterprisePartnershipHub";
import MobilitySolutionMatrix from "./sections/MobilitySolutionMatrix";
import GlobalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <MobilitySolutionsHero />
      <EnterprisePartnershipHub />
      <MobilitySolutionMatrix />
      <GlobalFooter />
    </div>;
}